import FormattedMessage from 'I18n/components/FormattedMessage';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import StyledZeroState from './StyledZeroState';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const message = inboxName => {
  return inboxName && inboxName.length > 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.zeroState",
    options: {
      inboxName
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.noInboxName"
  });
};
const SearchResultsZeroState = ({
  inboxName
}) => /*#__PURE__*/_jsxs(StyledZeroState, {
  children: [/*#__PURE__*/_jsx(Illustration, {
    name: "empty-state-charts",
    width: "200px"
  }), /*#__PURE__*/_jsx(Text, {
    as: "h5",
    color: "icon-core-subtle",
    margin: "600",
    textAlign: "center",
    children: message(inboxName)
  })]
});
SearchResultsZeroState.displayName = 'SearchResultsZeroState';
export default SearchResultsZeroState;